import React from 'react';
import { AuthLayout } from '@/components/domain/auth/AuthLayout';
import { getTelemetrySessionId } from '@/services/application-insights';
import { AlertMessage } from '@/ui-kit';

const ErrorPage: React.FC = () => {
  // The error boundary renders this page with no props, so it reads the session itself.
  const sessionId = getTelemetrySessionId();

  return (
    <AuthLayout>
      <AlertMessage
        variant="danger"
        title="Oops! Something went wrong"
        description={
          <>
            An unexpected error has occurred. Please try again later.
            {sessionId && (
              <p className="font-nunito text-sm leading-normal text-neutral-darker">
                If you contact support, please quote reference{' '}
                <strong>{sessionId}</strong>.
              </p>
            )}
          </>
        }
        icon="left"
      />
    </AuthLayout>
  );
};

export default ErrorPage;
